'use client'

import type { RefObject } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from './icon-sprite'

/**
 * Prev/next for a moving rail, plus the position marker (FRIDGE-1093, docs/Design.md §22.3:
 * "dots or a progress bar show the position"). The bar's fill is driven by
 * hooks/use-moving-rail through `progressRef` — a transform written per frame, no React
 * state — so it costs nothing while the rail drifts.
 */
export function MovingRailControls({ label, move, progressRef }: {
  label: string; move: (direction: number) => void; progressRef?: RefObject<HTMLElement | null>
}) {
  const cls = 'inline-flex h-9 min-w-9 items-center justify-center rounded-full border border-gray-200 bg-white px-2 text-sm text-gray-700 hover:border-[#ff9951] focus-visible:outline-2 focus-visible:outline-[#ff9951]'
  return (
    <div className="flex items-center gap-3 py-2" role="group" aria-label={`${label} controls`}>
      {progressRef ? (
        <span data-rail-progress className="block h-[3px] flex-1 overflow-hidden rounded-full bg-gray-200" aria-hidden="true">
          <span ref={progressRef as RefObject<HTMLSpanElement | null>} className="block h-full w-full origin-left rounded-full bg-[#ff9951]" style={{ transform: 'scaleX(0)' }} />
        </span>
      ) : <span className="flex-1" />}
      <button type="button" className={cls} aria-label={`Scroll ${label} back`} onClick={() => move(-1)}><ChevronLeftIcon className="h-4 w-4" aria-hidden="true" /></button>
      <button type="button" className={cls} aria-label={`Scroll ${label} forward`} onClick={() => move(1)}><ChevronRightIcon className="h-4 w-4" aria-hidden="true" /></button>
    </div>
  )
}
